<template>
  <div>
    <v-card outlined>
      <v-card-title>
        Individual Managed Space Selection
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Find a managed space"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="tableItems"
        :search="search"
        show-group-by
        multi-sort dense
        v-model="selected"
        item-key="id"
        :show-select="true"
        :single-select="singleSelect"
        :footer-props="{ 'items-per-page-options': [20, 50, 100, -1]}"
      >
        <!--
        <template v-slot:top>
          <v-switch
            v-model="singleSelect"
            label="Single select"
            class="pa-3"
          ></v-switch>
        </template>
        -->
      </v-data-table>
    </v-card>
    <div v-if="false">
      <v-card>
        <v-card-title>Debug</v-card-title>
        <v-card-text>
          <!-- <p>Headers {{ headers }}</p> -->
          <!-- <p>Table Items {{ tableItems }}</p> -->
          <p>Selected {{ selected }}</p>
          <!-- <p>Table Items {{ tableItems }}</p>
          <p>Data {{ managedSpaces }}</p> -->
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'managedspaceselectfrombuilding',
  props: {
    managedSpaces: Array,
    value: Array
  },
  data: () => {
    return {
      singleSelect: false,
      headers: [
        { text: 'Name', value: 'name', filterable: true, groupable: false },
        { text: 'Floor', value: 'floorNumber', filterable: true, groupable: true },
        { text: 'Space Type', value: 'spaceType', groupable: true },
        { text: 'Department', value: 'department', groupable: true },
        { text: 'Capacity People', value: 'capacityPeople', groupable: true },
        { text: 'Capacity Restricted', value: 'capacityPeopleRestricted', groupable: true }
      ],
      search: '',
      selected: []
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    }
  },
  computed: {
    tableItems: function () {
      // console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ Compute table items @@@@@@@@@@@@@@@@@@@@@')
      if (!this.managedSpaces) {
        return []
      }
      return this.managedSpaces.map(space => {
        // console.log('Occupancy', space.sensor.occupancy)
        var arr = space.managedspacegrouphasmanagedspace_set
        var theType
        var department
        arr.forEach(element => {
          if (element.managedspacegroup.managedspacegroupset.name === 'Space Type') {
            theType = element.managedspacegroup.name
          }
          if (element.managedspacegroup.managedspacegroupset.name === 'Department') {
            department = element.managedspacegroup.name
          }
        })
        return {
          id: space.id,
          name: space.name,
          spaceType: theType,
          department: department,
          capacityPeople: space.capacitypeople,
          capacityPeopleRestrictd: space.capacitypeoplerestricted,
          floorNumber: space.floornumber
        }
      })
    }
  },
  methods: {}
}
</script>

<style scoped>

.mytext {
  font-size: 12px;
}

.short {
  width: 48px;
  font-size: 12px;
  height: 16px;
  margin: 0px;
  padding: 0px;
  justify-content: center;
}

</style>
